document.addEventListener('DOMContentLoaded', function () {

    const select = document.querySelector('.custom-select');
    select.classList.add('hidden');
    const closest = select.closest('.wpcf7-form-control-wrap');
    const options = select.querySelectorAll('option');
    const div = document.createElement('div');
    div.classList.add('cs');

    const p = document.createElement('p');
    p.classList.add('cs_current');

    const ul = document.createElement('ul');
    ul.classList.add('cs_list');

    for (let j = 0; j < options.length; j++) {
        const option = options[j];
        const li = document.createElement('li');
        li.classList.add('another-f');
        li.innerHTML = option.textContent;

        if (j === 0) {
            p.innerHTML = option.textContent;
        }
        const text = li.textContent
        li.addEventListener('click', function () {
            select.selectedIndex = j;
            p.textContent = text;
            ul.classList.remove('active');
            p.classList.remove('active');
        });

        ul.appendChild(li);
    }

    if (closest) {
        div.append(p);
        div.append(ul);
        closest.append(div);
    }

    p.addEventListener('click', () => {
        ul.classList.toggle('active');
        p.classList.toggle('active');
    })
})
